import React, {useState} from 'react'
import Tr from "translations/Translations";
import clsx from "clsx";
import {Badge, makeStyles, Typography} from "@material-ui/core";
import MailIcon from "@material-ui/icons/Mail";
import GridBlock from "components/GridBlock";
import BoldTypography from "components/BoldTypography";
import moment from "moment";
import DateFormats from "constants/DateFormats";
import FilesList from "components/FilesList";
import WorkableIconButton from "components/button/WorkableIconButton";
import GetAppIcon from "@material-ui/icons/GetApp";
import PropTypes from "prop-types";
import CorrespondenceService from "services/CorrespondenceService";

const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2),
    },
    contentWrapper: {
        border: `solid 1px ${theme.palette.primary.main}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
        position: 'relative'
    },
    contentWrapperUnread: {
        borderWidth: 3
    },
    content: {
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
    },
    sendDate: {
        margin: `0 ${theme.spacing(1)}px`,
        minWidth: 110
    },
    message: {
        whiteSpace: 'pre-line',
        margin: `${theme.spacing(2)}px 0`
    },
    newBadge: {
        position: 'absolute',
        right: 0,
        top: 3
    },
}));

function GeneralInfoPublicAnswersMessage(
    {
        demandId,
        index,
        message,
        currentRfxRoundId,
    }) {

    const classes = useStyles();
    const [downloadZipWorking, setDownloadZipWorking] = useState(false);
    const unread = !message.read;

    const downloadZip = () => {
        setDownloadZipWorking(true);
        CorrespondenceService.downloadContractorMessageAttachmentsZip(currentRfxRoundId, message.messageId, () => setDownloadZipWorking(false));
    }

    const downloadAttachment = (attachment) => {
        CorrespondenceService.downloadContractorMessageAttachment(currentRfxRoundId, attachment.identity)
    }

    return (
        <div className={clsx(classes.root)}>

            <div className={clsx(classes.contentWrapper, {[classes.contentWrapperUnread]: unread})}>
                <div className={classes.content}>
                    {unread && <Badge className={clsx(classes.newBadge)} badgeContent='NOWA' color="error">
                        <MailIcon color='primary'/>
                    </Badge>}
                    <GridBlock justify='flex-end'>
                        <BoldTypography variant='caption'>{Tr("answer_date")}:</BoldTypography>
                        <Typography variant='caption' component='p' className={classes.sendDate}>
                            {message.publishDate ? moment(message.publishDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT) : ''}
                        </Typography>
                    </GridBlock>

                    <Typography variant='body1' className={classes.message}>{message.contents}</Typography>

                    {!!message?.attachments?.length && <>
                        <BoldTypography>{Tr('attachment')}</BoldTypography>
                        <FilesList
                            elements={message.attachments}
                            onDownload={downloadAttachment}
                            customAction={
                                <WorkableIconButton
                                    tooltip={Tr('download_all_message_attachments')}
                                    Icon={GetAppIcon}
                                    onClick={downloadZip}
                                    working={downloadZipWorking}/>
                            }/>
                    </>}
                </div>
            </div>
        </div>
    )
}

GeneralInfoPublicAnswersMessage.propTypes = {
    message: PropTypes.object.isRequired,
    currentRfxRoundId: PropTypes.number.isRequired
}

export default GeneralInfoPublicAnswersMessage;
